/**
 * Элемент справочника.
 * Используется для простых справочников, состоящих из идентификатора и
 * отображения значения.
 */
export class Reference {
    /**
     * Уникальный идентификатор элемента справочника.
     */
    readonly id: string;

    /**
     * Наименование. Используется для представления элемента справочника пользователю.
     */
    readonly name: string;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }

    static empty() {
        return new Reference(null, null);
    }
}
